export const ENVIROMENTS = {
  PRODUCTION: 'production',
  SANDBOX: 'sandbox',
}
